/**
 * Флаг доступа к «Горячим окнам» на сущности project в Firebase:
 * /project/<projectId>/isHotWindowsEnabled = true
 *
 * Ставится тумблером в админке и приходит на фронт как есть в объекте проекта
 * (mapProject отдаёт всю сущность), поэтому отдельного запроса не нужно.
 */
export const HOT_WINDOWS_PROJECT_FLAG = 'isHotWindowsEnabled'

export interface HotWindowsProjectLike {
    id?: string
    isHotWindowsEnabled?: boolean
}

export function hasHotWindowsAccess(project?: HotWindowsProjectLike | null): boolean {
    return Boolean(project?.id) && project?.[HOT_WINDOWS_PROJECT_FLAG] === true
}
